import styled, { css } from 'styled-components';

import { UpdateMessage } from 'libs/ui';

export const UpdateMessageStyled = styled(UpdateMessage)`
  top: 480px;
  left: 33%;
`;

export const ToggleBox = styled.div`
  position: absolute;
  right: 20px;
  top: 20px;
  display: flex;
  align-items: center;
  p {
    font-size: 15px;
  }
  p:first-child {
    color: ${(props) => (props.isActive ? '#dde3e7' : '#d33d34')};
  }
  p:last-child {
    color: ${(props) => (props.isActive ? '#17b26e' : '#dde3e7')};
  }
`;

export const Toggle = styled.div`
  width: 38px;
  height: 20px;
  cursor: pointer;
  border-radius: 21px;
  background-color: ${(props) => (props.isActive ? '#17b26e' : '#d33d34')};
  margin: 0 15px;
  padding: 1px;
  div {
    position: relative;
    width: 18px;
    height: 18px;
    background-color: #ffffff;
    border-radius: 50%;
    transition: all 0.2s;
    left: ${(props) => (props.isActive ? '18px' : '0')};
  }
  ${(props) =>
    props.disabled &&
    css`
      cursor: not-allowed;
    `}
`;
